<template>
  <div>
    <v-card-text class="pt-0">
      <div class="text-center" v-if="!hideBank">
        <v-btn-toggle small dense v-model="paymentType" color="primary">
          <v-btn outlined small value="card"> Credit/Debit Card </v-btn>

          <v-btn outlined small value="ach"> Bank Account </v-btn>
        </v-btn-toggle>
      </div>

      <div v-show="paymentType === 'card'">
        <div class="card-wrapper"></div>
        <form id="editCard" class="mt-5">
          <v-row>
            <v-col cols="12" sm="12">
              <v-text-field
                id="cardNumber"
                outlined
                dense
                type="tel"
                :autofocus="autofocus"
                :background-color="`${card.cardNumber ? false : '#E8F5E9'}`"
                :error-messages="cardNumberErrors"
                :hide-details="cardNumberErrors.length === 0"
                v-model.trim="card.cardNumber"
                label="Card Number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-text-field
                id="nameOnCard"
                outlined
                dense
                :background-color="`${card.cardNumber ? false : '#E8F5E9'}`"
                :error-messages="NameOnCardErrors"
                :hide-details="NameOnCardErrors.length === 0"
                v-model.trim="card.nameOnCard"
                label="Name On Card"
              ></v-text-field>
            </v-col>

            <v-col sm="6" md="6">
              <v-text-field
                id="cardExpiry"
                outlined
                dense
                type="tel"
                v-mask="'##/##'"
                :background-color="`${card.expiryDate ? false : '#E8F5E9'}`"
                :error-messages="expiryDateErrors"
                :hide-details="expiryDateErrors.length === 0"
                v-model.trim="card.expiryDate"
                label="Expiry Date"
              ></v-text-field>
            </v-col>
            <v-col sm="6" md="6">
              <v-text-field
                id="cvvCode"
                outlined
                dense
                type="tel"
                :background-color="`${card.cvvCode ? false : '#E8F5E9'}`"
                :error-messages="cvvCodeErrors"
                :hide-details="cvvCodeErrors.length === 0"
                v-model.trim="card.cvvCode"
                label="CVV Code"
              ></v-text-field>
            </v-col>
          </v-row>
        </form>
      </div>

      <!-- <v-row class="mt-2" v-show="paymentType === 'ach'"> -->
      <v-row class="mt-2" v-show="paymentType === 'ach' && !hideBank">
        <v-col>
          <v-img
            class="pointer"
            height="175"
            contain
            src="@/assets/images/check_jpg.jpeg"
          />
        </v-col>

        <v-col cols="12">
          <div class="mb-2 text-center">Account Type?</div>
          <div class="text-center">
            <v-btn-toggle small dense v-model="accountType" color="primary">
              <v-btn outlined small value="checking"> Checking </v-btn>

              <v-btn outlined small value="savings"> Savings </v-btn>
            </v-btn-toggle>
          </div>
        </v-col>

        <v-col cols="12" sm="12">
          <v-text-field
            outlined
            dense
            :error-messages="accountNameErrors"
            :hide-details="accountNameErrors.length === 0"
            :background-color="`${
              paymentMethod.accountName ? false : '#E8F5E9'
            }`"
            v-model="paymentMethod.accountName"
            label="Name On Account"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-text-field
            outlined
            dense
            :error-messages="routingNumberErrors"
            :hide-details="routingNumberErrors.length === 0"
            type="tel"
            :background-color="`${
              paymentMethod.routingNumber ? false : '#E8F5E9'
            }`"
            v-model.trim="paymentMethod.routingNumber"
            label="Routing Number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-text-field
            outlined
            dense
            :error-messages="accountNumberErrors"
            :hide-details="accountNumberErrors.length === 0"
            type="tel"
            :background-color="`${
              paymentMethod.accountNumber ? false : '#E8F5E9'
            }`"
            v-model.trim="paymentMethod.accountNumber"
            label="Account Number"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");
import applicationService from "@/modules/Application/service.js";
import payCompassService from "@/modules/PayCompass/service.js";
const encryptor = require("simple-encryptor")(process.env.VUE_APP_KEY);
// import customerService from "@/modules/Customer/service.js";

export default {
  name: "card-collection",
  props: [
    "localCollectOnly",
    "hideBank",
    "customer",
    "donor",
    "sponsor",
    "public",
    "donationCategoryId",
    "autofocus",
  ],
  // props: {
  //   localCollectOnly: {
  //     default: false,
  //   },
  //   hideBank: {
  //     default: false,
  //   },
  //   customer: {
  //     default: null,
  //   },
  //   donor: {
  //     default: null,
  //   },
  //   sponsor: {
  //     default: null,
  //   },
  //   public: {
  //     default: false,
  //   },
  // },
  data() {
    return {
      paymentMethod: {
        accountName: null,
        routingNumber: null,
        accountNumber: null,
      },
      accountType: "checking",
      paymentType: "card",
      dialog: false,
      card: {
        nameOnCard: null,
        cardNumber: null,
        expiryDate: null,
        cvvCode: null,
      },
      cardSize: 300,
      showCard: false,
      loading: false,
      notFound: false,
      showValue: false,
      // cardCollected: false,
      complete: false,
      stripe: null,
    };
  },
  mixins: [validationMixin],
  validations: {
    card: {
      nameOnCard: {
        required,
        minLength: minLength(4),
      },
      cardNumber: {
        required,
      },
      expiryDate: {
        required,
      },
      cvvCode: {
        required,
      },
    },
    paymentMethod: {
      accountName: {
        required,
      },
      routingNumber: {
        required,
      },
      accountNumber: {
        required,
      },
    },
  },
  computed: {
    NameOnCardErrors() {
      const errors = [];
      if (!this.$v.card.nameOnCard.$dirty) return errors;
      if (!this.$v.card.nameOnCard.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.card.nameOnCard.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    cardNumberErrors() {
      const errors = [];
      if (!this.$v.card.cardNumber.$dirty) return errors;
      if (!this.$v.card.cardNumber.required)
        errors.push("Card Number is required");
      return errors;
    },
    expiryDateErrors() {
      const errors = [];
      if (!this.$v.card.expiryDate.$dirty) return errors;
      if (!this.$v.card.expiryDate.required)
        errors.push("Expiry Date is required");
      return errors;
    },
    cvvCodeErrors() {
      const errors = [];
      if (!this.$v.card.cvvCode.$dirty) return errors;
      if (!this.$v.card.cvvCode.required) errors.push("CVV Code is required");
      return errors;
    },
    accountNameErrors() {
      const errors = [];
      if (!this.$v.paymentMethod.accountName.$dirty) return errors;
      if (!this.$v.paymentMethod.accountName.required)
        errors.push("Account name is required");
      return errors;
    },
    routingNumberErrors() {
      const errors = [];
      if (!this.$v.paymentMethod.routingNumber.$dirty) return errors;
      if (!this.$v.paymentMethod.routingNumber.required)
        errors.push("Routing number is required");
      return errors;
    },
    accountNumberErrors() {
      const errors = [];
      if (!this.$v.paymentMethod.accountNumber.$dirty) return errors;
      if (!this.$v.paymentMethod.accountNumber.required)
        errors.push("Account number is required");
      return errors;
    },
  },
  created() {
    this.$events.listen("submitCreditCard", () => this.submit());
    this.$events.listen("closeCreditCard", () => this.cancel());
    if (this.$vuetify.breakpoint.xsOnly) {
      this.cardSize = 200;
    }
    // console.log('size', this.cardSize, this.$vuetify.breakpoint.xsOnly)
    setTimeout(() => {
      // console.log('i got call')
      this.mountCard();
    }, 100);
  },
  beforeDestroy() {
    // console.log('beforeDestroy get call')
    this.$events.remove("submitCreditCard");
    this.$events.remove("closeCreditCard");
  },
  watch: {
    hideBank: {
      immediate: true,
      handler(val) {
        if (val) this.paymentType = "card";
      },
    },
  },
  // watch: {
  //   dialog(val) {
  //     if (val) {
  //       setTimeout(() => {
  //         console.log('i got call')
  //         this.mountCard()
  //       }, 100);
  //     }
  //   }
  // },
  methods: {
    mountCard() {
      // eslint-disable-next-line no-use-before-define
      let card = new Card({
        form: "form#editCard", // *required*

        container: ".card-wrapper", // *required*

        formSelectors: {
          numberInput: "input#cardNumber",
          expiryInput: "input#cardExpiry",
          cvcInput: "input#cvvCode",
          nameInput: "input#nameOnCard",
        },

        width: this.cardSize,
        formatting: true,

        // Strings for translation - optional
        messages: {
          validDate: "valid\ndate", // optional - default 'valid\nthru'
          monthYear: "mm/yy",
        },
        placeholders: {
          number: "•••• •••• •••• ••••",
          name: "Full Name",
          expiry: "••/••",
          cvc: "•••",
        },

        // if true, will log helpful messages for setting up Card
        debug: false, // optional - default false
      });
      console.log("card", card);
    },
    reset() {
      this.card = {
        nameOnCard: null,
        cardNumber: null,
        expiryDate: null,
        cvvCode: null,
      };
      (this.paymentMethod = {
        accountName: null,
        routingNumber: null,
        accountNumber: null,
      }),
        (this.accountType = "checking");
      this.paymentType = "card";
      this.$v.card.$reset();
      this.$v.paymentMethod.$reset();
    },
    cancel() {
      this.reset();
    },
    async submit() {
      if (this.paymentType === "card") {
        this.$v.card.$touch();
        if (this.$v.card.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: this.$t("toastMessage.text.invalidFields"),
            });
          return false;
        }
      } else {
        this.$v.paymentMethod.$touch();
        if (this.$v.paymentMethod.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: this.$t("toastMessage.text.invalidFields"),
            });
          return false;
        }
      }
      try {
        this.loading = true;

        let data = {};

        data.accountType = this.accountType;
        data.paymentType = this.paymentType;
        if (this.customer) {
          data.CustomerId = this.customer.id;
        }
        if (this.donor) {
          data.DonorId = this.donor.id;
        }

        if (this.customer && this.customer.BusinessId) {
          data.BusinessId = this.customer.BusinessId;
        }

        if (this.donor && this.donor.BusinessId) {
          data.BusinessId = this.donor.BusinessId;
        }

        if (this.sponsor) {
          data.sponsor = this.sponsor;
        }

        let card = null;
        if (this.paymentType === "card") {
          const expiryDate = this.card.expiryDate.split("/");
          card = {
            name: this.card.nameOnCard,
            number: this.card.cardNumber.replace(/\s/g, ""),
            exp_month: expiryDate[0],
            exp_year: `20${expiryDate[1]}`,
            cvc: this.card.cvvCode,
          };
        } else {
          card = {
            name: this.paymentMethod.accountName,
            routing_number: this.paymentMethod.routingNumber,
            account_type: data.accountType,
            sec_code: "PPD",
            account_number: this.paymentMethod.accountNumber,
          };
        }

        // console.log('data card', card)
        data.card = encryptor.encrypt(JSON.stringify(card));
        data.donationCategoryId = this.donationCategoryId;

        // if (this.customer) {
        //   data.customer = true
        // } else {
        //   data.donor = true
        // }

        if (this.localCollectOnly) {
          this.$emit("submit", data);
          return true;
        }

        if (this.public) {
          this.collectPublicCard(data);
        } else {
          this.collectCard(data);
        }
      } catch (error) {
        this.loading = false;
        console.log("error adding card3", error);
      }
    },
    collectPublicCard(data) {
      applicationService
        .publicAddCard(data)
        .then(() => {
          this.reset();
          this.$emit("submit");
        })
        .catch((error) => {
          this.loading = false;
          console.log("error adding card", error);
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: error.data.message,
            });
        });
    },
    collectCard(data) {
      console.log("collectCard", data);
      console.log("customer", this.customer);
      console.log("donor", this.donor);
      // return false
      payCompassService
        .addCard(data)
        .then(() => {
          //console.log('add card response working', response)
          // this.cardCollected = true;
          this.reset();
          this.$emit("submit");
        })
        .catch((error) => {
          this.loading = false;
          console.log("error adding card2", error);
          this.$swal("Payment!", error.data.message, "error");
        });
    },
  },
};
</script>

<style scoped></style>